export default __webpack_public_path__ + "static/media/qr-icon.b81a1fe5.svg";